import { render, staticRenderFns } from "./base.vue?vue&type=template&id=0d1550d5&lang=pug&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1550d5')) {
      api.createRecord('0d1550d5', component.options)
    } else {
      api.reload('0d1550d5', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=0d1550d5&lang=pug&", function () {
      api.rerender('0d1550d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/base.vue"
export default component.exports